// Dependencies
import React, { FunctionComponent } from "react";

// Types
import { BottomSheetProps } from "./bottom-sheet.types";

// Styles
import { Container, InnerContainer, Wrapper, ContentWrapper, Label, ActionButtonsWrapper } from "./bottom-sheet.styles";

// Components
import { Overlay } from "components/Overlay";
import { ConditionallyRender } from "component-library/utilities/conditionally-render";

export const BottomSheet: FunctionComponent<BottomSheetProps> = ({
    label,
    content,
    type = "default",
    actionButtonCompositions,
    handleOutsideClick
}) => {
    return (
        <Overlay
            handleOutsideClick={handleOutsideClick}
            content={
                <Wrapper className="webapp-bottom-sheet">
                    <Container>
                        <InnerContainer>
                            <Label>{label}</Label>

                            <ContentWrapper type={type}>{content}</ContentWrapper>
                        </InnerContainer>

                        <ConditionallyRender
                            shouldRender={!!actionButtonCompositions}
                            content={<ActionButtonsWrapper>{actionButtonCompositions}</ActionButtonsWrapper>}
                        />
                    </Container>
                </Wrapper>
            }
        />
    );
};
